<ag-shr-modal-window
  #agentDispositionModalRef
  [title]="agentDispositionFormDataSig() | agentInfoModalTitle | async"
  [width]="'74vw'"
  [height]="'auto'"
  [inProgress]="inProgress$ | async"
  (onSaveClick)="handleSave()"
  [onCloseModal]="handleFormPopupClose"
  [showSaveButton]="canEditHierarchy"
  [extraToolbarItems]="
    canCreateApproveDenyReason
      ? (agentDispositionFormDataSig()?.agent_status
        | agentDispositionModalControls
          : approveDenyReasonEditorConfigSig()?.[ApproveDenyReasonKeys.visibilityLevel]
          : handleChangeAgentStatusClick)
      : []
  "
>
  @if (agentDispositionModalRef?.popupComponent?.visible) {
    <dx-form
      #agentDispositionFormRef
      [formData]="agentDispositionFormDataSig()"
      labelMode="floating"
      [readOnly]="!canEditHierarchy"
      [validationGroup]="agentDispositionValidationGroup"
      [colCount]="4"
      class="agent-disposition-modal__form"
    >
      <dxi-item itemType="group" [colCount]="2" [colSpan]="3">
        @if (agentTypeVisible) {
          <dxi-item
            [dataField]="AgentKeys.agent_type"
            editorType="dxSelectBox"
            [editorOptions]="{ items: agentTypesSig(), valueExpr: 'value', displayExpr: 'description' }"
          >
            <dxo-label [text]="'Agent Type'"></dxo-label>
          </dxi-item>
        }

        @if (uplineVisible) {
          <dxi-item [dataField]="AgentKeys.upline">
            <dxo-label [text]="'Upline'"></dxo-label>
          </dxi-item>
        }

        @if (mgaVisible) {
          <dxi-item
            [dataField]="AgentKeys.p_mga_id"
            [label]="{ text: 'MGA' }"
            editorType="dxSelectBox"
            [editorOptions]="{
              items: mgasSig(),
              readOnly: !canEditMGA || isMgaLeadSig(),
              valueExpr: AgencyKeys.agencyId,
              displayExpr: AgencyKeys.name,
              searchEnabled: true,
              showClearButton: true,
              placeholder: '',
            }"
          ></dxi-item>

          <dxi-item
            [dataField]="AgentKeys.p_agency_id"
            [label]="{ text: 'Agency' }"
            editorType="dxSelectBox"
            [editorOptions]="{
              items: mgaAgenciesSig(),
              readOnly: isMgaLeadSig(),
              valueExpr: AgencyKeys.agencyId,
              displayExpr: AgencyKeys.name,
              searchEnabled: true,
              showClearButton: true,
              placeholder: '',
            }"
          ></dxi-item>
        }

        @if (agentIdVisible) {
          <dxi-item [dataField]="AgentKeys.p_agent_id">
            <div *dxTemplate>
              <dx-text-box
                #agentIdInput
                [labelMode]="'floating'"
                [label]="'Agent Id'"
                [(value)]="agentDispositionFormDataSig()[AgentKeys.p_agent_id]"
              >
                <dx-validator [validationGroup]="agentIdValidationGroup">
                  <dxi-validation-rule
                    type="async"
                    [validationCallback]="uniqAgentIdValidationCallback"
                    [message]="'Same Agent Id already assigned'"
                    [reevaluate]="true"
                  ></dxi-validation-rule>
                </dx-validator>

                <dxi-button
                  name="forceValidate"
                  location="after"
                  [options]="{
                    icon: 'check',
                    hint: 'Bypass Validation',
                    stylingMode: 'text',
                    type: 'danger',
                    visible: agentIdInput?.validationStatus === 'invalid',
                    onClick: handleBypassValidation,
                  }"
                ></dxi-button>

                <dxi-button
                  name="generateAgentId"
                  location="after"
                  [options]="{
                    icon: 'key',
                    disabled: false,
                    template: 'buttonTemplate',
                    hint: 'Generate Agent ID',
                    visible:
                      !agentDispositionFormDataSig()?.[AgentKeys.p_agent_id] && Entity.agentGenerateAgentId
                      | hasPermission
                      | async,

                    onClick: generateAgentId,
                  }"
                >
                  <div *dxTemplate="let data of 'buttonTemplate'">
                    @if (isAgentIdGenerationInProgress$ | async) {
                      <dx-load-indicator [visible]="true" height="20" width="20"></dx-load-indicator>
                    } @else {
                      <i class="dx-icon dx-icon-key"></i>
                    }
                  </div>
                </dxi-button>

                <dxi-button
                  name="agencyLead"
                  location="after"
                  [options]="{
                    icon: 'agi-star',
                    hint: 'Agency Lead Id',
                    stylingMode: 'text',
                    disabled: true,
                    visible: !isManagerFieldVisibleSig(),
                    elementAttr: { class: 'agent-disposition-modal__lead-button' },
                  }"
                ></dxi-button>
              </dx-text-box>
            </div>
          </dxi-item>
        }

        @if (mgaVisible) {
          <dxi-item [dataField]="AgentKeys.p_external_agent_id" [label]="{ text: 'External Id' }"></dxi-item>

          <dxi-item
            [dataField]="AgentKeys.manager_id"
            [label]="{ text: 'Team Lead' }"
            editorType="dxSelectBox"
            [editorOptions]="{
              dataSource: agencyManagersDataSourceSig(),
              valueExpr: AgentKeys.p_agent_id,
              displayExpr: AgentKeys.p_agent_name,
              searchEnabled: true,
              showClearButton: true,
              validationMessagePosition: 'top',
              placeholder: '',
              disabled: !isManagerFieldVisibleSig(),
              searchExpr: [AgentKeys.p_agent_first_name, AgentKeys.p_agent_last_name, AgentKeys.p_email],
            }"
          >
            <dxi-validation-rule
              type="async"
              [ignoreEmptyValue]="true"
              [message]="'Circular Team Lead Assignment'"
              [validationCallback]="asyncManagerAssignmentValidation"
            ></dxi-validation-rule>
          </dxi-item>
        }
      </dxi-item>

      <dxi-item itemType="group">
        @if (mgaVisible) {
          <dxi-item
            [dataField]="AgentKeys.is_manager"
            [label]="{ text: 'Is Team Lead' }"
            cssClass="agency-management__switch ag-switch-with-label"
            editorType="dxSwitch"
            [editorOptions]="{ switchedOffText: 'No', switchedOnText: 'Yes' }"
          ></dxi-item>
        }
        @if (agencyDirectorVisible) {
          <dxi-item
            [dataField]="AgentKeys.is_credited"
            [label]="{ text: 'Agency Director' }"
            cssClass="agency-management__switch ag-switch-with-label"
            [alignItemLabels]="'left'"
            editorType="dxSwitch"
            [editorOptions]="{ switchedOffText: 'No', switchedOnText: 'Yes' }"
          ></dxi-item>
        }
        @if (isRMDVisible) {
          <dxi-item
            [dataField]="AgentKeys.is_rmd"
            [label]="{ text: 'Is RMD' }"
            cssClass="agency-management__switch ag-switch-with-label"
            [alignItemLabels]="'left'"
            editorType="dxSwitch"
            [editorOptions]="{ switchedOffText: 'No', switchedOnText: 'Yes' }"
          ></dxi-item>
        }
      </dxi-item>
    </dx-form>
    <ng-container>
      <ag-shr-approve-deny-reasons-grid
        *ngIf="canViewApproveDenyReason && !!agentDispositionFormDataSig()?.[BaseModelKeys.dbId]"
        [agentDbId]="agentDispositionFormDataSig()?.[BaseModelKeys.dbId]"
        [title]="'Agent Status Activity'"
        [canCreate]="canCreateApproveDenyReason"
        [canEdit]="canEditApproveDenyReason"
        [canDelete]="canDeleteApproveDenyReason"
        [allowedVisibilityLevels]="approveDenyReasonsAllowedVisibilityLevelsSig()"
        [editModalOptions]="approveDenyReasonEditorConfigSig()"
      ></ag-shr-approve-deny-reasons-grid>
    </ng-container>

    <ag-shr-modal-window
      #promptModelRef
      [title]="'Reassign Manager'"
      [modalId]="transferPromptModalId"
      [width]="'520px'"
      [height]="'auto'"
      [actionTitle]="'CONTINUE'"
      *var="agentDispositionFormDataSig()?.[AgentKeys.p_agent_name] as agentName"
    >
      <p>
        {{ agentName }} is a team lead for
        <a
          href="{{ promptSettingsSig()?.teamListUrl }}"
          target="_self"
          download="{{ agentName }} Team.xlsx"
          style="text-decoration: underline"
        >
          {{ promptSettingsSig()?.teamSize }} agent(s)</a
        >.
      </p>

      <p>You need to assign a new team lead for {{ agentName }}'s teammates before saving changes.</p>
    </ag-shr-modal-window>

    <ag-shr-modal-window
      #transferAgentModalRef
      [title]="'Reassign Teammates'"
      [isFullScreen]="true"
      [modalId]="transferModalId"
      [actionTitle]="'CONFIRM'"
      [width]="'100%'"
      [height]="'100%'"
      [useScrollView]="false"
      [inProgress]="inTransferInProgress$ | async"
      [extraToolbarItems]="[
        {
          widget: 'dxButton',
          location: 'before',
          toolbar: 'bottom',
          visible: hasHierarchyChangesSig(),
          options: {
            icon: 'undo',
            type: 'danger',
            hint: 'Revert Last Change',
            onClick: revertChange,
          },
        },
      ]"
    >
      @if (transferAgentModalRef?.popupComponent?.visible) {
        <ag-crm-agency-hierarchy-management
          #hierarchyManagementRef
          [mode]="AgencyHierarchyManagerMode.agentTransfer"
          [unassignedGridTitle]="'Transfered Agents'"
        ></ag-crm-agency-hierarchy-management>
      }
    </ag-shr-modal-window>
  }
</ag-shr-modal-window>

<ag-shr-modal-window
  #updateAgentStatusModalRef
  [width]="450"
  [height]="'auto'"
  [inProgress]="isUpdateStatusInProgress"
  [title]="changeAgentStatusConfig?.title"
  [actionTitle]="changeAgentStatusConfig?.actionTitle"
  (onSaveClick)="handleChangeAgentStatus($event)"
>
  <dx-form #updateAgentStatusFormRef labelMode="floating" [readOnly]="!canEditHierarchy">
    <dxi-item
      dataField="reason"
      [isRequired]="changeAgentStatusConfig?.reasonRequired"
      [label]="{ text: 'Reason' }"
      [editorType]="'dxTextArea'"
      [editorOptions]="{ height: 150 }"
    ></dxi-item>
  </dx-form>
</ag-shr-modal-window>
